export default __webpack_public_path__ + "static/flag-se-6b0cbb0ce442fceb2ad1ae292868c019.svg";